// Namespaced to this extension specifically (not just 'rnlic:activeJourneyContext')
// because sessionStorage is shared across every widget on the Liferay page.
// A sibling <term-insurance-journey> / <tulip-plan> would otherwise overwrite
// this context and send post-payment / in-app navigation to Term.
const JOURNEY_CONTEXT_KEY = 'rnlic:activeJourneyContext:retirement-plan';

const DEFAULT_CONTEXT = Object.freeze({
  journeyType: 'nischit-pension',
  formNames: {},
  routePath: '/retirement-plan',
});

let inMemoryContext = { ...DEFAULT_CONTEXT };

const canUseSessionStorage = () =>
  typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

const sanitizeContext = (nextContext = {}) => {
  const journeyType =
    typeof nextContext.journeyType === 'string' && nextContext.journeyType.trim()
      ? nextContext.journeyType.trim()
      : DEFAULT_CONTEXT.journeyType;

  const formNames =
    nextContext.formNames && typeof nextContext.formNames === 'object'
      ? Object.entries(nextContext.formNames).reduce((acc, [key, value]) => {
          if (
            typeof key === 'string' &&
            key.trim() &&
            typeof value === 'string' &&
            value.trim()
          ) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {})
      : {};

  const routePath =
    typeof nextContext.routePath === 'string' && nextContext.routePath.trim()
      ? (nextContext.routePath.startsWith('/') ? nextContext.routePath.trim() : `/${nextContext.routePath.trim()}`)
      : DEFAULT_CONTEXT.routePath;

  return { journeyType, formNames, routePath };
};

export const setCurrentJourneyContext = (nextContext = {}) => {
  inMemoryContext = sanitizeContext(nextContext);
  if (!canUseSessionStorage()) return inMemoryContext;
  try {
    window.sessionStorage.setItem(JOURNEY_CONTEXT_KEY, JSON.stringify(inMemoryContext));
  } catch {
    // Ignore storage errors and keep in-memory context.
  }
  return inMemoryContext;
};

export const getCurrentJourneyContext = () => {
  if (!canUseSessionStorage()) return inMemoryContext;
  try {
    const raw = window.sessionStorage.getItem(JOURNEY_CONTEXT_KEY);
    if (!raw) return inMemoryContext;
    const parsed = JSON.parse(raw);
    inMemoryContext = sanitizeContext(parsed);
  } catch {
    // Ignore parse/storage errors and keep in-memory context.
  }
  return inMemoryContext;
};
